/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const QUESTIONS = [
  {
    id: "role",
    type: "single",
    question: "What best describes you?",
    icon: "👤",
    options: ["Student", "Developer", "Designer", "Researcher", "Teacher / Professor", "Other"],
  },
  {
    id: "year",
    type: "single",
    question: "What year are you in?",
    icon: "🎓",
    options: ["1st Year", "2nd Year", "3rd Year", "4th Year", "Post Graduate", "Working Professional"],
  },
  {
    id: "usage",
    type: "single",
    question: "What will you mainly use VaultSphere for?",
    icon: "🎯",
    options: ["Storing project files", "Collaborating with teammates", "Organising assignments", "Storing certificates", "All of the above"],
  },
  {
    id: "features",
    type: "multi",
    question: "Which features do you find most useful?",
    icon: "⭐",
    options: ["AI File Analysis", "Team Collaboration", "Analytics Dashboard", "Version History", "Certificate Storage", "Public Share Links"],
  },
  {
    id: "rating",
    type: "rating",
    question: "How would you rate VaultSphere overall?",
    icon: "🌟",
  },
  {
    id: "design",
    type: "single",
    question: "How do you like the design?",
    icon: "🎨",
    options: ["Love it! 😍", "It's good 👍", "Could be better 😐", "Needs work 🔧"],
  },
  {
    id: "improvement",
    type: "single",
    question: "What would you most like to see improved?",
    icon: "🔧",
    options: ["Faster performance", "More AI features", "Better mobile experience", "More storage space", "Dark mode", "Nothing — it's great!"],
  },
  {
    id: "recommend",
    type: "single",
    question: "Would you recommend VaultSphere to a friend?",
    icon: "💬",
    options: ["Definitely yes! 🚀", "Probably yes", "Not sure", "Probably not"],
  },
  {
    id: "feedback",
    type: "text",
    question: "Any other feedback or suggestions?",
    icon: "✍️",
    placeholder: "Tell us what you think… (optional)",
  },
];

export default function Survey() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const QUESTIONS = [
    {
      id: "role", type: "single", question: t("survey_q1"), icon: "👤",
      options: [t("survey_q1_o1"), t("survey_q1_o2"), t("survey_q1_o3"), t("survey_q1_o4"), t("survey_q1_o5"), t("survey_q1_o6")]
    },
    {
      id: "year", type: "single", question: t("survey_q2"), icon: "🎓",
      options: [t("survey_q2_o1"), t("survey_q2_o2"), t("survey_q2_o3"), t("survey_q2_o4"), t("survey_q2_o5"), t("survey_q2_o6")]
    },
    {
      id: "usage", type: "single", question: t("survey_q3"), icon: "🎯",
      options: [t("survey_q3_o1"), t("survey_q3_o2"), t("survey_q3_o3"), t("survey_q3_o4"), t("survey_q3_o5")]
    },
    {
      id: "features", type: "multi", question: t("survey_q4"), icon: "⭐",
      options: [t("survey_q4_o1"), t("survey_q4_o2"), t("survey_q4_o3"), t("survey_q4_o4"), t("survey_q4_o5"), t("survey_q4_o6")]
    },
    { id: "rating", type: "rating", question: t("survey_q5"), icon: "🌟" },
    {
      id: "design", type: "single", question: t("survey_q6"), icon: "🎨",
      options: [t("survey_q6_o1"), t("survey_q6_o2"), t("survey_q6_o3"), t("survey_q6_o4")]
    },
    {
      id: "improvement", type: "single", question: t("survey_q7"), icon: "🔧",
      options: [t("survey_q7_o1"), t("survey_q7_o2"), t("survey_q7_o3"), t("survey_q7_o4"), t("survey_q7_o5"), t("survey_q7_o6")]
    },
    {
      id: "recommend", type: "single", question: t("survey_q8"), icon: "💬",
      options: [t("survey_q8_o1"), t("survey_q8_o2"), t("survey_q8_o3"), t("survey_q8_o4")]
    },
    { id: "feedback", type: "text", question: t("survey_q9"), icon: "✍️", placeholder: t("survey_q9_placeholder") },
  ];

  const q = QUESTIONS[step];

  const setAnswer = (id, val) => setAnswers(a => ({ ...a, [id]: val }));
  const toggleMulti = (id, val) => {
    const cur = answers[id] || [];
    setAnswers(a => ({ ...a, [id]: cur.includes(val) ? cur.filter(x => x !== val) : [...cur, val] }));
  };
  const canNext = () => q.type === "text" ? true : q.type === "multi" ? (answers[q.id] || []).length > 0 : !!answers[q.id];

  const submit = async () => {
    setSubmitting(true);
    try {
      await API.post("/users/survey", { answers });
      localStorage.setItem("vs_survey_done", "1");
      setDone(true);
    } catch {
      localStorage.setItem("vs_survey_done", "1");
      setDone(true);
    } finally { setSubmitting(false); }
  };

  const skip = () => { localStorage.setItem("vs_survey_done", "1"); navigate("/dashboard"); };

  if (done) return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "var(--font-body)" }}>
      <div style={{ textAlign: "center", color: "var(--text)", maxWidth: 420 }}>
        <div style={{ fontSize: 72, marginBottom: 20 }}>🎉</div>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 28, marginBottom: 12 }}>{t("survey_done_title")}</h2>
        <p style={{ fontSize: 15, color: "var(--text-2)", lineHeight: 1.7, marginBottom: 28 }}>{t("survey_done_desc")}</p>
        <button onClick={() => navigate("/dashboard")} style={{ padding: "14px 32px", borderRadius: 14, border: "none", background: "var(--accent)", color: "var(--on-accent)", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          {t("survey_done_btn")}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "var(--font-body)" }}>
      <div style={{ width: "100%", maxWidth: 540, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 24, overflow: "hidden", boxShadow: "var(--shadow-lg)" }}>

        {/* Progress bar */}
        <div style={{ height: 4, background: "var(--surface-2)" }}>
          <div style={{ height: "100%", background: "var(--accent)", transition: "width .4s ease", width: ((step + 1) / QUESTIONS.length * 100) + "%" }} />
        </div>

        <div style={{ padding: "24px 28px 28px" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-3)", textTransform: "uppercase", letterSpacing: "1px" }}>
              {step + 1} {t("survey_of")} {QUESTIONS.length}
            </div>
            <button onClick={skip} style={{ background: "none", border: "none", fontSize: 12, color: "var(--text-3)", cursor: "pointer", fontFamily: "inherit" }}>
              {t("survey_skip")}
            </button>
          </div>

          <div style={{ fontSize: 36, marginBottom: 10 }}>{q.icon}</div>
          <h2 style={{ fontFamily: "var(--font-display)", fontSize: 20, color: "var(--text)", marginBottom: 20 }}>{q.question}</h2>

          {/* Single select */}
          {q.type === "single" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {q.options.map(opt => (
                <button key={opt} onClick={() => setAnswer(q.id, opt)}
                  style={{
                    padding: "12px 16px", borderRadius: 12,
                    border: "1.5px solid " + (answers[q.id] === opt ? "var(--accent)" : "var(--border)"),
                    background: answers[q.id] === opt ? "var(--accent-tint)" : "transparent",
                    color: answers[q.id] === opt ? "var(--accent)" : "var(--text-2)",
                    fontFamily: "inherit", fontSize: 13, fontWeight: answers[q.id] === opt ? 700 : 400,
                    cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center",
                    justifyContent: "space-between", transition: "all .15s"
                  }}>
                  {opt}
                  {answers[q.id] === opt && <span>✓</span>}
                </button>
              ))}
            </div>
          )}

          {/* Multi select */}
          {q.type === "multi" && (
            <>
              <p style={{ fontSize: 12, color: "var(--text-3)", marginBottom: 12 }}>{t("survey_select_all")}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {q.options.map(opt => {
                  const sel = (answers[q.id] || []).includes(opt);
                  return (
                    <button key={opt} onClick={() => toggleMulti(q.id, opt)}
                      style={{
                        padding: "8px 16px", borderRadius: 20,
                        border: "1.5px solid " + (sel ? "var(--accent)" : "var(--border)"),
                        background: sel ? "var(--accent-tint)" : "transparent",
                        color: sel ? "var(--accent)" : "var(--text-2)", fontFamily: "inherit",
                        fontSize: 13, fontWeight: sel ? 700 : 400, cursor: "pointer", transition: "all .15s"
                      }}>
                      {opt}
                    </button>
                  );
                })}
              </div>
            </>
          )}

          {/* Star rating */}
          {q.type === "rating" && (
            <div style={{ display: "flex", gap: 10, justifyContent: "center", margin: "8px 0" }}>
              {[1, 2, 3, 4, 5].map(n => (
                <button key={n} onClick={() => setAnswer(q.id, n)}
                  style={{
                    width: 54, height: 54, borderRadius: 14,
                    border: "1.5px solid " + (answers[q.id] >= n ? "var(--accent)" : "var(--border)"),
                    background: answers[q.id] >= n ? "var(--accent-tint)" : "transparent",
                    fontSize: 26, cursor: "pointer", transition: "all .15s"
                  }}>
                  {answers[q.id] >= n ? "⭐" : "☆"}
                </button>
              ))}
            </div>
          )}

          {/* Text */}
          {q.type === "text" && (
            <textarea placeholder={q.placeholder} value={answers[q.id] || ""}
              onChange={e => setAnswer(q.id, e.target.value)} rows={4}
              style={{
                width: "100%", padding: "14px 16px", borderRadius: 14,
                border: "1.5px solid var(--border)", background: "var(--surface-2)",
                fontFamily: "inherit", fontSize: 14, color: "var(--text)", resize: "none",
                outline: "none", lineHeight: 1.6, boxSizing: "border-box"
              }} />
          )}

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 24 }}>
            <button onClick={() => setStep(s => s - 1)} disabled={step === 0}
              style={{ padding: "10px 20px", borderRadius: 12, border: "1.5px solid var(--border-strong)", background: "transparent", color: "var(--text-3)", fontFamily: "inherit", fontSize: 13, fontWeight: 600, cursor: step === 0 ? "not-allowed" : "pointer", opacity: step === 0 ? .4 : 1 }}>
              {t("survey_back")}
            </button>
            <div style={{ display: "flex", gap: 5 }}>
              {QUESTIONS.map((_, i) => (
                <div key={i} onClick={() => i < step && setStep(i)}
                  style={{ width: i === step ? 18 : 6, height: 6, borderRadius: 3, background: i <= step ? "var(--accent)" : "var(--surface-3)", transition: "all .2s", cursor: i < step ? "pointer" : "default" }} />
              ))}
            </div>
            {step < QUESTIONS.length - 1 ? (
              <button onClick={() => canNext() && setStep(s => s + 1)}
                style={{ padding: "10px 24px", borderRadius: 12, border: "none", background: canNext() ? "var(--surface)" : "var(--surface-3)", color: "var(--text)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: canNext() ? "pointer" : "not-allowed" }}>
                {t("survey_next")}
              </button>
            ) : (
              <button onClick={submit} disabled={submitting}
                style={{ padding: "10px 24px", borderRadius: 12, border: "none", background: "var(--accent)", color: "var(--on-accent)", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
                {submitting ? t("survey_submitting") : t("survey_submit")}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}